<div class="row justify-content-center">

    <div class="col-xl-12">
        <!-- card -->
        <div class="card card-h-100">
            <!-- card body -->
            <div class="card-body">


                <div class="row align-items-center">
                    
                    <div class="col-sm-12 align-self-center">
                        <div class="mt-4 mt-sm-0">
                            <p class="mb-1">Status Atual:</p>
                            <h4>{{ documento.descricaoStatus }}</h4>

                            <div class="mt-2">
                                @if(documento.statusDocumentoAssinatura == 6 || documento.statusDocumentoAssinatura ==
                                5)
                                {
                                <button disabled type="button"
                                    class="d-flex btn btn-light waves-effect waves-light w-sm">
                                    <i class="me-2 bx bx-error d-block font-size-16"></i> Documento Cancelado!
                                </button>
                                }@else {
                                <div class="d-flex justify-content-between gap-2 mt-4">

                                    <button (click)="cancelarDocumentoClick(documento.documentoUuId)" type="button" class="d-flex btn btn-danger waves-effect waves-light w-sm">
                                        <i class="me-2 mdi mdi-trash-can d-block font-size-16"></i> Cancelar documento
                                    </button>
                                    @if(documento.statusDocumentoAssinatura == 4){

                                        <button (click)="baixarDocumento(documento.documentoUuId!)" class=" d-flex btn btn-primary waves-effect waves-light w-sm">
                                            <i class="me-2 mdi mdi-download d-block font-size-16"></i> Baixar documento
                                        </button>
                                    }@else {
                                        <button title="Somente será disponível para download após finalizar processo de assinatura" disabled class=" d-flex btn btn-light waves-effect waves-light w-sm">
                                            <i class="me-2 mdi mdi-download d-block font-size-16"></i> (Aguardando Assinaturas) Baixar documento
                                        </button>
                                    }
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>